import { useEffect, useState } from 'react';
import { useSmartProp } from '@smartfire/js-block-engine';
import apiFetch from '@wordpress/api-fetch';
import { useSelect } from '@wordpress/data';

import {
    ColorPalette,
    PanelBody,
    PanelRow,
    SelectControl,
    TextControl,
    ToggleControl,
    BaseControl,
} from '@wordpress/components';

const Inspector = () => {
    const [text, setText] = useSmartProp('text');
    const [linkType, setLinkType] = useSmartProp('linkType');
    const [blank, setBlank] = useSmartProp('blank');
    const [link, setLink] = useSmartProp('link');
    const [aspect, setAspect] = useSmartProp('aspect');

    // Contained
    const [backgroundContained, setBackgroundContained] = useSmartProp('backgroundContained');
    const [colorContained, setColorContained] = useSmartProp('colorContained');
    const [borderContained, setBorderContained] = useSmartProp('borderContained');

    // Ghost
    const [styleGhost, setStyleGhost] = useSmartProp('styleGhost');

    const colors = useSelect('core/block-editor').getSettings().colors;

    const [pages, setPages] = useState([]);

    useEffect(() => {
        apiFetch({ path: 'wp/v2/pages?per_page=-1' }).then((data) => {
            let pagesList = data.map((el) => {
                return {
                    value: el.link,
                    label: el.title.rendered,
                };
            });
            setPages(pagesList);
        });
    }, []);

    return (
        <>
            <PanelBody title="Contenu" initialOpen={true}>
                <PanelRow>
                    <TextControl label={'Text'} value={text} onChange={setText} />
                </PanelRow>
            </PanelBody>
            <PanelBody title={'Lien'}>
                <PanelRow>
                    <ToggleControl
                        label={linkType === 'internal' ? 'Interne' : 'Externe'}
                        checked={linkType === 'external'}
                        onChange={(value) => {
                            setLinkType(value ? 'external' : 'internal');
                            setLink('');
                        }}
                    />
                </PanelRow>
                {linkType === 'internal' || linkType === 'external' ? (
                    <>
                        <PanelRow>
                            <ToggleControl label="Ouvrir dans un nouvel onglet" checked={blank} onChange={setBlank} />
                        </PanelRow>
                        <PanelRow>
                            {linkType === 'internal' ? (
                                <SelectControl label="Lien" value={link} onChange={setLink} options={pages} />
                            ) : (
                                <TextControl label="Lien" value={link} onChange={setLink} />
                            )}
                        </PanelRow>
                    </>
                ) : null}
            </PanelBody>
            <PanelBody title={'Styles'} initialOpen={true}>
                <PanelRow>
                    <SelectControl
                        label="Aspect"
                        value={aspect}
                        onChange={setAspect}
                        options={[
                            { value: 'contained', label: 'Plein' },
                            { value: 'ghost', label: 'Ghost' },
                        ]}
                    />
                </PanelRow>
                {aspect === 'contained' && (
                    <>
                        <PanelRow>
                            <BaseControl label="Couleur background">
                                <ColorPalette
                                    colors={colors}
                                    value={backgroundContained}
                                    onChange={setBackgroundContained}
                                    disableCustomColors={true}
                                    clearable={false}
                                ></ColorPalette>
                            </BaseControl>
                        </PanelRow>
                        <PanelRow>
                            <BaseControl label="Couleur texte">
                                <ColorPalette
                                    colors={colors}
                                    value={colorContained}
                                    onChange={setColorContained}
                                    disableCustomColors={true}
                                    clearable={false}
                                ></ColorPalette>
                            </BaseControl>
                        </PanelRow>
                        <PanelRow>
                            <BaseControl label="Couleur bordure">
                                <ColorPalette
                                    colors={colors}
                                    value={borderContained}
                                    onChange={setBorderContained}
                                    disableCustomColors={true}
                                    clearable={false}
                                ></ColorPalette>
                            </BaseControl>
                        </PanelRow>
                    </>
                )}
                {aspect === 'ghost' && (
                    <PanelRow>
                        <SelectControl
                            label="Type"
                            value={styleGhost}
                            onChange={setStyleGhost}
                            options={[
                                { value: 'style-1', label: 'Style 1' },
                                { value: 'style-2', label: 'Style 2' },
                            ]}
                        />
                    </PanelRow>
                )}
            </PanelBody>
        </>
    );
};

export default Inspector;
